var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagGha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2372 3649)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_GHA",
    transform: "translate(-2372 -3649)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_gana",
    transform: "translate(2350.309 3649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_465",
    "data-name": "Ret\\xE2ngulo 465",
    width: 102.859,
    height: 19.993,
    transform: "translate(0 40.008)",
    fill: "#2d6c41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_466",
    "data-name": "Ret\\xE2ngulo 466",
    width: 102.859,
    height: 20.005,
    transform: "translate(0 20.003)",
    fill: "#f3d02f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_467",
    "data-name": "Ret\\xE2ngulo 467",
    width: 102.859,
    height: 20.005,
    transform: "translate(0)",
    fill: "#bc0030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7009",
    "data-name": "Caminho 7009",
    d: "M479.33,19h6.68l2.052-6.344L490.129,19H496.8l-5.386,3.915,2.052,6.334-5.4-3.916-5.387,3.916,2.054-6.334Z",
    transform: "translate(-436.639 9.046)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGha);
export default __webpack_public_path__ + "static/media/flag_GHA.52d77eecde9945e4c1b756bf3e01e9d6.svg";
export { ForwardRef as ReactComponent };